import * as React from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}

function SvgComponent({ title, titleId, ...props }: React.SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M10.001 3.774a5 5 0 017.065 7.053L10 17.904l-7.066-7.076a5 5 0 017.067-7.053z"
                fill="currentColor"
            />
        </svg>
    );
}

export default SvgComponent;
